import { ReportView } from '../components/ReportView';

export function Reports() {
  return (
    <div style={{ padding: '1rem', maxWidth: '1200px', margin: '0 auto' }}>
      <ReportView />
    </div>
  );
}
